import axios from 'axios'
import { getBackendUrl } from "@/general";

const BASE_URL = "/movimientos/api/";

export const dataGridDocumentosDian = async (context, page, search, status) => {
  try {
    const parameters = {
      "status": status,
      "page": page,
      "search": search
    }

    await context.$store.dispatch('statusLogin', context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/movimientos/api/dataGridDocumentosDian/`,
      {
        params: parameters,
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response
  }
}

export const crudDocumentoDian = async (context, typeAction, id, requestData) => {
  const ENDPOINT = "documentoDian";

  let response;

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${BASE_URL}${ENDPOINT}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        response = await axios.get(
          `${source}${BASE_URL}${ENDPOINT}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        console.log("Under construction...");
        break;
      case "delete":
        response = await axios.delete(
          `${source}${BASE_URL}${ENDPOINT}/${id}`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "patch":
        response = await axios.patch(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "get": {
          const parameters = {
            "Modulo": requestData.modulo
          }
          response = await axios.get(
            `${source}${BASE_URL}${ENDPOINT}/`,
            {
              params: parameters,
              headers: paramsHeader
            }
          );
          break;
        }
    }

    return response.data;
  } catch (err) {
    console.log(err.response);
    throw err
  }
}

export const dataGridMovimientosDocumentoElectronico = async (context, page, search, filters) => {
  const parameters = {
    "page": page,
    "search": search
  }

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/movimientos/api/dataGridMovimientosDocumentoDian/${filters}/`,
      {
        params: parameters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const crudMovimientosDocumentoDian = async (context, typeAction, id, requestData) => {
  const ENDPOINT = "movimientoDocumentoDian";

  let response;

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${BASE_URL}${ENDPOINT}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        response = await axios.get(
          `${source}${BASE_URL}${ENDPOINT}${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        console.log("Under construction...");
        break;
      case "delete":
        response = await axios.delete(
          `${source}${BASE_URL}${ENDPOINT}/${id}`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "patch":
        response = await axios.patch(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "get": {
          const parameters = {
            "Modulo": requestData.modulo
          }
          response = await axios.get(
            `${source}${BASE_URL}${ENDPOINT}/`,
            {
              params: parameters,
              headers: paramsHeader
            }
          );
          break;
        }
    }

    return response.data;
  } catch (err) {
    console.log(err.response);
    throw err
  }
}
